import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { Label } from 'rbx';
import { toast } from 'react-toastify';

// import uuidv4 from 'uuid/v4';
// import gql from 'graphql-tag';
// import { differenceBy } from 'lodash';

// import client from '../../../../utils/apolloClient';
import { CheckBox, Loading, Select } from '../../../../components/elements';
import {
  getLinksAndMenuItem,
  parseLinkAndMenuItem_forSearchItemModal,
} from '../helpers';
import DiscountValueInput from './DiscountValueInput';

const mergeLinksAndMenuItem = (links, menuItem) =>
  links
    .map(parseLinkAndMenuItem_forSearchItemModal(menuItem))
    .filter(ele => ele);

const Container = styled.div`
  &&& {
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      height: 100vh;
      padding: 0px;
    }
    .modal-card {
      max-height: calc(100vh - 20%);
      position: absolute;
      width: 60%;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      border-bottom: 0px;
      padding: 1.5rem 1rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: flex-end;
      border: 0px;
      padding: 1rem;
      background: white;
    }
    a {
      font-size: 1rem;
    }
  }
`;

const SecondaryHeader = styled.div`
  background: white;
`;
const InputWrapper = styled.div`
  padding: 1rem;
  width: 50%;
`;

const EmptyMessage = styled.div`
  padding: 0 1rem;
  font-size: 16px;
  color: black;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 2rem;
`;

const discountTypeOptions = [
  { value: 'PERCENTAGE', label: '% rate' },
  { value: 'PRICE', label: 'flat rate' },
];

const SearchItemModal = ({
  placeId,
  menuId,
  onSubmit,
  isActive,
  onClose,
  initialsItems,
  isSubmitting,
  isBogoDeal,
  isOfferItem,
  isSelectFromListOffer,
  minimumPriceToCompare,
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [discountType, setDiscountType] = useState({
    value: 'PERCENTAGE',
    label: '% rate',
  });
  const [discountValue, setDiscountValue] = useState();
  const [preSelectedItems, setPreSelectedItems] = useState([]);
  const numberOfItemsSelected =
    Array.isArray(selectedItems) && selectedItems?.length !== 0
      ? selectedItems?.length
      : 0;

  const fetchItems = useCallback(async value => {
    setLoading(true);
    try {
      const response = await getLinksAndMenuItem(
        {
          sort: 'NAME_ASC',
          from: 0,
          size: 1000,
          // search_criteria: 'Chicken',
          // user_id: userId,
          filter: {
            menu_item_link_filter: {
              place_id: placeId,
              menu_id: menuId,
              status: 'ACTIVE',
            },
          },
        },
        {
          sort: 'NAME_ASC',
          from: 0,
          size: 1000,
          filter: {
            menu_item_filter: {
              place_id: placeId,
              status: 'ACTIVE',
              name: value || undefined,
            },
            menu_filter: {
              menu_id: menuId,
            },
          },
        },
      );

      const initialItemsSet = new Set(initialsItems || []);

      if (isOfferItem) {
        setItems(
          mergeLinksAndMenuItem(
            response.search_menu_item_links.menu_item_link_listing.filter(
              ele => !initialItemsSet.has(ele.item_link_id),
            ),
            response.search_menu_items.menu_item_listing,
          )
            .filter(ele => !ele?.meta_data?.has_variant)
            .filter(ele => ele.menu_item_price < minimumPriceToCompare),
        );
      } else {
        setItems(
          mergeLinksAndMenuItem(
            response.search_menu_item_links.menu_item_link_listing.filter(
              ele => !initialItemsSet.has(ele.item_link_id),
            ),
            response.search_menu_items.menu_item_listing,
          ),
        );
      }

      if (isBogoDeal && !value) {
        const temp = mergeLinksAndMenuItem(
          response.search_menu_item_links.menu_item_link_listing.filter(ele =>
            initialItemsSet.has(ele.item_link_id),
          ),
          response.search_menu_items.menu_item_listing,
        );

        setPreSelectedItems(temp);
        setSelectedItems(temp);
      }

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, []);

  const onSearch = value => {
    fetchItems(value);
  };

  useEffect(() => {
    fetchItems();
    setSelectedItems([]);
  }, [initialsItems]);

  const addItem = item => {
    setSelectedItems(selectedItems.concat({ ...item }));
  };

  const removeItem = id => {
    setSelectedItems(selectedItems.filter(item => item.item_link_id !== id));
  };

  return (
    <Container className={`modal ${isActive && 'is-active'}`}>
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            {isSelectFromListOffer ? 'Add Item' : 'Add Items'}
          </p>
          <button
            type="button"
            className="delete"
            aria-label="close"
            onClick={onClose}
          />
        </header>
        <SecondaryHeader>
          <InputWrapper>
            <div className="field">
              <p className="control has-icons-left has-icons-right">
                <input
                  className="input"
                  type="search"
                  placeholder="Search menu items..."
                  onChange={e => onSearch(e.target.value)}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-search" />
                </span>
              </p>
            </div>
            {!isBogoDeal && (
              <GridContainer>
                <Select
                  label="Discount Type"
                  value={discountType}
                  options={discountTypeOptions}
                  onChange={value => {
                    setDiscountType(value);
                  }}
                  isRequired
                />
                <div
                  style={{
                    marginTop: 'auto',
                    position: 'relative',
                    bottom: '10px',
                  }}
                >
                  <Label>Discount Value</Label>
                  <DiscountValueInput
                    label="Discount Value"
                    value={discountValue}
                    price=""
                    discountType={discountType?.value}
                    onChange={e => setDiscountValue(e.target.value)}
                  />
                </div>
              </GridContainer>
            )}
          </InputWrapper>
        </SecondaryHeader>

        <section className="modal-card-body">
          {isBogoDeal && (
            <>
              {isSelectFromListOffer && (
                <div
                  style={{
                    float: 'left',
                    fontSize: '14px',
                    margin: '12px',
                  }}
                >
                  Please Select an Item!
                </div>
              )}
              <div
                style={{
                  float: 'right',
                  color: '#00AEEF',
                  fontSize: '14px',
                  margin: '12px',
                }}
              >
                Selected - {numberOfItemsSelected}
              </div>
            </>
          )}
          <table style={{ fontSize: '12px' }} className="table is-fullwidth">
            <thead>
              <tr>
                <th />
                <th>
                  <abbr>Item Name</abbr>
                </th>
                <th>
                  <abbr>Internal Name</abbr>
                </th>
                <th>
                  <abbr>Category</abbr>
                </th>
                <th>
                  <abbr>Has Variants</abbr>
                </th>
              </tr>
            </thead>
            <tbody>
              {isBogoDeal &&
                preSelectedItems.length !== 0 &&
                preSelectedItems.map(item => (
                  <tr>
                    <td>
                      <CheckBox
                        value={
                          selectedItems.filter(
                            edge => edge.item_link_id === item.item_link_id,
                          ).length !== 0
                        }
                        onChange={value =>
                          value
                            ? addItem({ ...item })
                            : removeItem(item.item_link_id)
                        }
                      />
                    </td>
                    <td style={{ fontWeight: '600' }}>{item.name}</td>
                    <td style={{ fontSize: '12px', color: '#737373' }}>
                      {item?.meta_data?.internal_name}
                    </td>
                    <td style={{ fontWeight: '600' }}>
                      {item?.meta_data?.menu_section_name}
                    </td>
                    <td style={{ fontSize: '12px', color: '#737373' }}>
                      {item?.meta_data?.has_variant ? 'Yes' : 'No'}
                    </td>
                  </tr>
                ))}
              {!loading &&
                items.map(item => (
                  <tr>
                    <td>
                      <CheckBox
                        value={
                          selectedItems.filter(
                            edge => edge.item_link_id === item.item_link_id,
                          ).length !== 0
                        }
                        onChange={value =>
                          value
                            ? addItem({ ...item })
                            : removeItem(item.item_link_id)
                        }
                      />
                    </td>
                    <td style={{ fontWeight: '600' }}>{item.name}</td>
                    <td style={{ fontSize: '12px', color: '#737373' }}>
                      {item?.meta_data?.internal_name}
                    </td>
                    <td style={{ fontWeight: '600' }}>
                      {item?.meta_data?.menu_section_name}
                    </td>
                    <td style={{ fontSize: '12px', color: '#737373' }}>
                      {item?.meta_data?.has_variant ? 'Yes' : 'No'}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {loading && <Loading />}
          {!loading && items.length === 0 && (
            <EmptyMessage>
              <p>No Items Found</p>
            </EmptyMessage>
          )}
        </section>
        <footer className="modal-card-foot">
          <button
            type="button"
            className="button is-grey-light"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`button is-primary ${isSubmitting && 'is-loading'}`}
            onClick={async () => {
              if (isBogoDeal) {
                if (isSelectFromListOffer && !(selectedItems.length === 1)) {
                  toast.error('Please select only one item!');
                  return;
                }

                onSubmit({
                  selectedItems,
                  discountType: discountType.value,
                  discountValue: 0,
                });
              } else {
                if (!discountValue) {
                  toast.error('Please enter a discount value!');
                  return;
                }

                onSubmit({
                  selectedItems,
                  discountType: discountType.value,
                  discountValue,
                });
              }
            }}
            disabled={selectedItems.length === 0}
          >
            <p className="has-text-weight-semibold">
              {isSelectFromListOffer ? 'Add Item' : 'Add Item(s)'}
            </p>
          </button>
        </footer>
      </div>
    </Container>
  );
};

export default SearchItemModal;
